module.exports = __webpack_public_path__ + "static/media/10-15-8-Night.683268d0.jpg";